import { APIProvider } from '@vis.gl/react-google-maps'

const KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined

export function hasGoogleMapsKey(): boolean {
    return typeof KEY === 'string' && KEY.length > 0
}

// Map ID cần cho Advanced Markers (marker HTML tuỳ biến). Đặt Map ID thật ở
// VITE_GOOGLE_MAPS_MAP_ID cho production; DEMO_MAP_ID để chạy được ngay khi dev.
export const GOOGLE_MAPS_MAP_ID =
    (import.meta.env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined) ||
    'DEMO_MAP_ID'

/**
 * Bọc children bằng APIProvider của Google Maps. Nếu chưa cấu hình key thì vẫn
 * render children (không crash app) — component bản đồ tự hiển thị fallback.
 */
export function GoogleMapsProvider({
    children,
}: {
    children: React.ReactNode
}) {
    if (!hasGoogleMapsKey()) {
        return <>{children}</>
    }
    return (
        <APIProvider apiKey={KEY as string} language="vi" region="VN">
            {children}
        </APIProvider>
    )
}
